import React from 'react';
import { ControlToggleGroup } from '../controls';

function CompactToggleGroup({
  value,
  onChange,
  options = [],
  label,
  buttonWidth = 44,
  buttonHeight,
  mode = 'icon',
}) {
  return (
    <ControlToggleGroup
      context="filterBar"
      value={value}
      onChange={onChange}
      options={options}
      label={label}
      labelWidth={label ? 38 : 0}
      buttonWidth={buttonWidth}
      buttonHeight={buttonHeight}
      mode={mode}
    />
  );
}

export default CompactToggleGroup;
